import { components } from './components'
import { globals } from './globals'

const theme = {
  ...globals,
  ...components,
}

export default theme